<script lang="ts" setup>
import { useAdmissionReleaseInfo } from '@sancare/typescript-commons/src/composables/useAdmissionReleaseInfo'
import dayjs from '@sancare/typescript-commons/src/misc/dayjs'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { CountryEnum } from '@/store/modules/settings/types'
import { McoStayCh } from '@/store/modules/stay/mco/types'

const { t } = useI18n()

const props = defineProps<{
  stay: McoStayCh
}>()

const rum = computed(() => props.stay.rums[0] ?? null)

const facilityName = computed(
  () => props.stay.geographicEntity?.shortDescription
    ?? props.stay.legalEntity?.shortDescription
    ?? null,
)

const {
  admissionMode,
  releaseMode,
  origin,
  destination,
  admissionTooltip,
  releaseTooltip,
} = useAdmissionReleaseInfo(() => ({
  admissionMode: rum.value?.admissionMode ?? null,
  releaseMode: rum.value?.releaseMode ?? null,
  origin: rum.value?.origin ?? null,
  destination: rum.value?.destination ?? null,
}), CountryEnum.CH, t)
</script>

<template>
  <div class="row">
    <div class="col d-flex flex-column gap-2">
      <span class="ms-0 text-muted small">
        {{ t('stayDisplayer.stay') }}
      </span>
      <span class="ms-0 fw-bold text-nowrap">
        {{ dayjs(stay.stayStart).format('DD MMM YYYY') }} - {{ dayjs(stay.stayEnd).format('DD MMM YYYY') }}
        ({{ stay.stayDuration }}{{ t('stayDisplayer.dayShort') }})
      </span>
      <span class="ms-0">
        <span
          v-tooltip="{
            content: admissionTooltip,
            placement: 'top',
            html: true,
          }"
          class="cursor-pointer"
        >
          {{ t('stayDisplayer.generalStayData.entryDate') }}:
          {{ admissionMode }}/{{ origin }}
        </span>
        —
        <span
          v-tooltip="{
            content: releaseTooltip,
            placement: 'top',
            html: true,
          }"
          class="cursor-pointer"
        >
          {{ t('stayDisplayer.generalStayData.exitDate') }}:
          {{ releaseMode }}/{{ destination }}
        </span>
      </span>
      <span
        v-if="facilityName"
        class="ms-0"
      >
        {{ facilityName }}
      </span>
    </div>
    <div class="col d-flex flex-column gap-2 justify-content-center">
      <span class="ms-0">
        {{ t('stayDisplayer.mco.artificialVentilationDuration') }} : {{ rum?.artificialVentilationDuration ?? '-' }}
      </span>
      <span
        v-if="rum?.newbornWeight"
        class="ms-0"
      >
        {{ t('stayDisplayer.mco.newbornWeight') }} : {{ rum.newbornWeight }}
      </span>
      <span
        v-if="rum?.pregnancyDuration"
        class="ms-0"
      >
        {{ t('stayDisplayer.mco.pregnancyDuration') }} : {{ rum.pregnancyDuration }}
      </span>
    </div>
  </div>
</template>
